import { Link, Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/subscriber/history')({
  component: HistoryLayout,
});

function HistoryLayout() {
  return (
    <div className="mx-auto max-w-3xl">
      <h1 className="font-serif text-3xl text-ink">History</h1>
      <div className="mt-6 flex gap-1 border-b border-ink/10">
        <Link
          to="/subscriber/history/reading"
          className="-mb-px border-b-2 border-transparent px-4 py-2 text-sm text-ink/60 hover:text-ink"
          activeProps={{ className: '-mb-px border-b-2 border-oxblood px-4 py-2 text-sm text-ink' }}
        >
          Reading
        </Link>
        <Link
          to="/subscriber/history/watching"
          className="-mb-px border-b-2 border-transparent px-4 py-2 text-sm text-ink/60 hover:text-ink"
          activeProps={{ className: '-mb-px border-b-2 border-oxblood px-4 py-2 text-sm text-ink' }}
        >
          Watching
        </Link>
      </div>
      <Outlet />
    </div>
  );
}
